import type { AppCopy } from '../catalogs';

export const nlAppCopy = {
  welcomeHeading: 'Hoe kan ik je vandaag helpen?',
  thinking: 'Denken',
  scrollToBottom: 'Scroll naar beneden',
  reasoning: 'Redenering',
  reasoningInProgress: 'in uitvoering',
  citationPages: 'Pagina’s {first}–{last}',
  citationTitle: 'Bronfragment',
  citationLoading: 'Bron laden…',
  citationUnavailable: 'De geciteerde tekst is niet beschikbaar of je hebt geen toegang meer.',
  citationOpen: 'Bron openen',
  citationCopied: 'Bronvermelding gekopieerd',
  copy: 'Kopieer',
  more: 'Meer',
  tryAgain: 'Probeer het opnieuw',
  answerTruncated: 'Het antwoord bereikte de lengtelimiet en werd afgebroken.',
  continueAnswer: 'Antwoord voortzetten',
  exportMarkdown: 'Exporteren als Markdown',
  edit: 'Bewerken',
  cancel: 'Annuleer',
  update: 'Bijwerken',
  previous: 'Vorige',
  next: 'Volgende',
  messagePlaceholder: 'Stuur een bericht…',
  projectHomePlaceholder: 'Nieuwe chat in {project}',
  sharedChatEveryone: 'Iedereen bij {company} kan deze chat lezen',
  sharedChatOnePerson: '1 persoon kan deze chat lezen',
  sharedChatPeople: '{count} mensen kunnen deze chat lezen',
  forkedChatPlaceholder: 'Ga verder met je eigen koppelingen…',
  newAnswer: 'Nieuw antwoord',
  messageInput: 'Berichtinvoer',
  sendMessage: 'Bericht verzenden',
  stopGenerating: 'Stop met genereren',
  addAttachment: 'Bijlage toevoegen',
  removeFile: 'Bestand verwijderen',
  attachmentPreview: 'Voorbeeld van bijlage',
  imageAttachmentPreview: 'Voorbeeld van afbeeldingsbijlage',
  image: 'Afbeelding',
  openLink: 'koppeling openen',
  document: 'Documenteren',
  file: 'Bestand',
  attachment: 'bijlage',
  uploadFailed: 'uploaden is mislukt',
  uploading: 'uploaden',
  toolIncomplete: 'Onvolledig',
  toolActivity: 'Activiteit',
  activityThinking: 'Denkt na…',
  activityWriting: 'Schrijft…',
  activityWaiting: 'Wacht op je goedkeuring',
  activityStopped: 'Gestopt',
  activityCouldNotFinish: 'Kon niet worden voltooid',
  activitySources: 'bronnen',
  activityShowThinking: 'Denken tonen',
  activityOpen: 'Activiteit openen',
  activitySteps: 'Stappen',
  activitySourcesTab: 'Bronnen',
  activityUnavailable: 'Deze activiteit is niet beschikbaar.',
  activityInput: 'Invoer',
  activityOutput: 'Uitvoer',
  activityNoSources: 'Dit antwoord citeerde geen bronnen.',
  activityApprovedByReply: 'Goedgekeurd door je antwoord',

  toolRunning: 'Bezig',
  toolComplete: 'Voltooid',
  toolNeedsApproval: 'Goedkeuring nodig',
  toolInput: 'Invoer',
  toolCall: 'gereedschapsoproep',
  toolCalls: 'gereedschap oproepen',
  openMenu: 'Menu openen',
  closeMenu: 'Menu sluiten',
  close: 'Sluiten',
  showInTextField: 'Tonen in tekstveld',
  settings: 'Instellingen',
  appearance: 'Weergave',
  themeLight: 'Licht',
  themeDark: 'Donker',
  themeSystem: 'Systeem',
  themeChoiceHelp:
    'Geldt op al je apparaten. Systeem volgt de lichte of donkere modus van elk apparaat.',
  themeSaveFailed:
    'We konden de weergave niet opslaan, dus er is niets veranderd. Probeer het opnieuw.',
  toolUsed: 'Gebruikt hulpmiddel',
  toolCancelled: 'Geannuleerd hulpmiddel',
  toolResult: 'Resultaat:',
  toolError: 'Fout:',
  toolCancelledReason: 'Reden van geannuleerd:',
  approvalAllow: 'Toestaan',
  approvalAlwaysAllow: 'Altijd toestaan',
  approvalDeny: 'Weigeren',
  approvalAlwaysDeny: 'Altijd weigeren',
  approvalConfirm: 'Bevestig',
  approvalBack: 'Terug',
  approvalApprovedResult: 'Goedgekeurd door gebruiker',
  approvalDeniedResult: 'Gebruiker heeft uitvoering van tool geweigerd',
  logout: 'Uitloggen',
  loginOrCreateAccount: 'Inloggen / Account aanmaken',
  newChat: 'Nieuwe chat',
  untitledChat: 'Naamloze chat',
  previousChats: 'Vorige chats',
  openChat: 'Chat openen {title}',
  moreActionsForChat: 'Meer handelingen voor {title}',
  chatActions: 'Chat-acties',
  closeChatActions: 'Sluit chatacties',
  deleteChatQuestion: 'Chat verwijderen?',
  deleteChatDescription: 'De chat “{title}” wordt permanent verwijderd.',
  deleteChat: 'Chat verwijderen',
  keepChat: 'Chat behouden',
  delete: 'Verwijderen',
  deleting: 'Verwijderen…',
  chatDeleteFailed: 'De chat kon niet worden verwijderd. Probeer het opnieuw.',
  settingsDescription: 'Pas aan hoe de assistent voor u werkt.',
  settingsDesktopDescription: 'Pas aan hoe de assistent op u reageert.',
  personalization: 'Personalisatie',
  personalizationDescription: 'Pas de instructies aan die de assistent bij elk antwoord volgt.',
  languageAndRegion: 'Taal en regio',
  languageAndRegionDescription: 'Kies de taal en tijdzone.',
  memories: 'Herinneringen',
  memoriesDescription: 'Bekijk, bewerk of verwijder wat de assistent van u onthoudt.',
  account: 'Rekening',
  accountDescription: 'Beheer het account en permanente verwijdering van uw gegevens.',
  backToSettings: 'Terug naar instellingen',
  closeSettings: 'Instellingen sluiten',
  settingsCategories: 'Instellingen categorieën',
  yourSettings: 'Jouw instellingen',
  dataAndAccount: 'Gegevens en rekening',
  viewAndManageMemories: 'Bekijk en beheer wat de assistent onthoudt',
  loginToUseMemories: 'Log in om herinneringen te gebruiken',
  manageOrDeleteAccount: 'Beheer of verwijder het account',
  unsavedChanges: 'U heeft niet-opgeslagen wijzigingen',
  unsavedCloseDescription:
    'Als u de instellingen sluit, worden de wijzigingen op deze pagina verwijderd.',
  unsavedBackDescription: 'Als u teruggaat, worden de wijzigingen op deze pagina verwijderd.',
  continueEditing: 'Ga door met bewerken',
  discardChanges: 'Wijzigingen negeren',
  saveChanges: 'Wijzigingen opslaan',
  localSettingsNote: 'Opgeslagen in deze browser. Log in om op te slaan in uw account.',
  personality: 'Persoonlijkheid',
  personalityHelp: 'Aangepaste instructies die de assistent volgt bij elk antwoord',
  personalityPlaceholder:
    'Bijvoorbeeld: wees beknopt en concreet. Ik woon in Göteborg en hou van vegetarisch eten.',
  timezone: 'Tijdzone',
  searchTimezone: 'Tijdzones zoeken…',
  automaticBrowser: 'Automatisch (browser)',
  saved: '{date} opgeslagen',
  addMemory: 'Herinnering toevoegen',
  newMemory: 'Nieuwe herinnering',
  memoryPlaceholder: 'Bijvoorbeeld: Ik geef de voorkeur aan korte, concrete antwoorden.',
  editMemory: 'Herinnering bewerken',
  saveMemory: 'Herinnering opslaan',
  deleteMemory: 'Herinnering verwijderen',
  memorySaveFailed: 'Het geheugen kon niet worden opgeslagen. Probeer het opnieuw.',
  memoryLimitReached:
    'Je kunt maximaal 50 herinneringen opslaan. Verwijder er een voordat je een nieuwe toevoegt.',
  memoryInvalid:
    'Herinneringen mogen geen links bevatten. Verwijder de link en probeer het opnieuw.',
  memoryDeleteFailed: 'Het geheugen kon niet worden verwijderd. Probeer het opnieuw.',
  memoryLoadFailed: 'Herinneringen konden niet worden geladen.',
  loadingMemories: 'Herinneringen laden…',
  emptyMemories:
    'De assistent bewaart herinneringen over u terwijl u praat: wat u leuk vindt, waar u woont en wat u doet. Je kunt ze hier bekijken, bewerken en verwijderen.',
  deleteAccountHelp:
    'Verwijder het account en alle gerelateerde chats, herinneringen en instellingen definitief.',
  deleteAccount: 'Account verwijderen',
  deleteAccountQuestion: 'Het account definitief verwijderen?',
  deleteAccountDescription:
    'Alle chats, berichten, herinneringen, instellingen en inloggegevens worden verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
  deleteAccountConfirm: 'Ja, verwijder mijn account',
  accountDeleteFailed:
    'Het account kon niet worden verwijderd. Er is niets verwijderd. Probeer het opnieuw.',
  logoutEverywhereTitle: 'Alle apparaten',
  logoutEverywhereHelp:
    'Log uit op alle apparaten en browsers waar je account open is, ook op dit apparaat.',
  logoutEverywhere: 'Overal uitloggen',
  logoutEverywhereQuestion: 'Uitloggen op alle apparaten?',
  logoutEverywhereDescription:
    'Je moet opnieuw inloggen op alle apparaten en browsers, ook op dit apparaat. Je chats en instellingen blijven zoals ze zijn.',
  loggingOut: 'Uitloggen…',
  logoutEverywhereFailed:
    'We konden niet bevestigen dat je overal bent uitgelogd. Probeer het opnieuw, of controleer op een ander apparaat of je nog bent ingelogd.',
  settingsSaveFailed: 'Instellingen konden niet worden opgeslagen. Probeer het opnieuw.',
  customInstructions: 'Aangepaste instructies',
  notSet: 'Niet ingesteld',
  automaticLanguage: 'Automatische taal',
  automaticTimezone: 'automatische tijdzone',
  appLanguage: 'App-taal',
  appLanguageHelp:
    'Beheert de volledige app-interface en datums. Antwoorden van de assistent blijven de taal volgen waarin je schrijft.',
  automaticBrowserLanguage: 'Automatisch (browsertaal)',
  previousLanguageChoice: 'Vorige keuze: {language} ({locale})',
  previousLanguageChoiceCode: 'Vorige keuze ({locale})',
  canvasCopyLink: 'Link kopiëren',
  canvasLinkCopied: 'Link gekopieerd',
  actionUpdatedWithEdits: 'Bijgewerkt met uw wijzigingen',
  activityStepsDone: 'one:stap voltooid|other:stappen voltooid',
  activityResultsCount: 'one:resultaat|other:resultaten',
  canvasCopyLinkFailed: 'Link kon niet worden gekopieerd',
  canvasOpenInAgent: 'Openen in {agent}',
  canvasExpand: 'Uitvouwen',
  canvasExitFullView: 'Volledige weergave sluiten',
  webSourceUnread:
    'Gelinkt in dit antwoord. Poneva heeft deze pagina niet gelezen, dus er valt hier niets te tonen.',
  webSourceOpenOriginal: 'Origineel openen',
  toolProgressSettings: 'Je instellingen wijzigen…',
  toolProgressAgent: 'De agent aanmaken…',
  toolProgressConnections: 'Koppelingsopties zoeken…',
  toolProgressResult: 'Je resultaat voorbereiden…',
  toolProgressClarification: 'Een verduidelijking voorbereiden…',
  toolProgressKnowledge: 'Een voorgestelde kennisupdate voorbereiden…',
  toolProgressQuestion: 'Een vraag voor je voorbereiden…',
  toolProgressSkill: 'Je Skill vormgeven…',
  toolErrorSettings: 'Je instellingen zijn niet gewijzigd.',
  toolErrorAgent: 'De agent kon niet worden aangemaakt.',
  toolErrorConnections: 'Koppelingsopties konden niet worden geladen.',
  toolErrorResult: 'Het resultaat is niet opgeslagen.',
  toolErrorClarification: 'De verduidelijking kon niet worden voorbereid.',
  toolErrorKnowledge: 'De voorgestelde kennisupdate kon niet worden voorbereid.',
  toolErrorQuestion: 'De vraag kon niet worden voorbereid.',
  toolErrorSkill: 'Het Skill-concept kon niet worden opgeslagen.',
  toolErrorOpenSettings: 'Instellingen openen',
  toolErrorOpenAgents: 'Agents openen',
  toolErrorOpenConnections: 'Verbindingen openen',
  toolStepIncomplete: 'Deze stap is niet voltooid.',
  toolEarlierAttemptsFailed:
    'one:eerdere poging is niet gelukt|other:eerdere pogingen zijn niet gelukt',
} satisfies AppCopy;
